export var QueryKeys = /*#__PURE__*/ function(QueryKeys) {
    QueryKeys["LegalTerms"] = "LegalTerms";
    QueryKeys["Relationship"] = "Relationship";
    QueryKeys["Draft"] = "Draft";
    QueryKeys["ArchivedProposals"] = "ArchivedProposals";
    QueryKeys["CanResyncQbo"] = "CanResyncQbo";
    QueryKeys["CanResyncXero"] = "CanResyncXero";
    QueryKeys["ServiceTemplatesForBilling"] = "ServiceTemplatesForBilling";
    QueryKeys["Clients"] = "Clients";
    QueryKeys["CustomerDetail"] = "CustomerDetail";
    QueryKeys["ClientContacts"] = "ClientContacts";
    QueryKeys["RecentAgreements"] = "RecentAgreements";
    QueryKeys["Contacts"] = "Contacts";
    QueryKeys["ContactSummaries"] = "ContactSummaries";
    QueryKeys["ContactSummary"] = "ContactSummary";
    QueryKeys["ContactsMap"] = "ContactsMap";
    QueryKeys["ActiveServices"] = "ActiveServices";
    QueryKeys["ProposalTemplates"] = "ProposalTemplates";
    QueryKeys["ServiceBillingDetails"] = "ServiceBillingDetails";
    QueryKeys["GetInfo"] = "getInfo";
    QueryKeys["PromptSuggestions"] = "PromptSuggestions";
    QueryKeys["RichText"] = "RichText";
    QueryKeys["PdfUrl"] = "PdfUrl";
    QueryKeys["BillingSchedule"] = "BillingSchedule";
    QueryKeys["BillingTimeline"] = "BillingTimeline";
    QueryKeys["UserReferral"] = "UserReferral";
    QueryKeys["PayoutsSummary"] = "PayoutsSummary";
    QueryKeys["SalesSummary"] = "SalesSummary";
    QueryKeys["HistoricAgreementStats"] = "HistoricAgreementStats";
    QueryKeys["MonthlyEarnings"] = "MonthlyEarnings";
    QueryKeys["HistoricRevenueStats"] = "HistoricRevenueStats";
    QueryKeys["InvoicesDigest"] = "InvoicesDigest";
    QueryKeys["Proposals"] = "Proposals";
    QueryKeys["Drafts"] = "Drafts";
    QueryKeys["DraftsAiSearchResults"] = "DraftsAiSearchResults";
    QueryKeys["AgreementsAiSearchResults"] = "AgreementsAiSearchResults";
    QueryKeys["ActivityLog"] = "ActivityLog";
    QueryKeys["ActivityLogPreferences"] = "ActivityLogPreferences";
    QueryKeys["CustomPageTemplates"] = "CustomPageTemplates";
    QueryKeys["CustomPageText"] = "CustomPageText";
    QueryKeys["CustomPageDownloadUrl"] = "CustomPageDownloadUrl";
    QueryKeys["Invoice"] = "Invoice";
    QueryKeys["InvoiceDashboardPreferences"] = "InvoiceDashboardPreferences";
    QueryKeys["InvoiceMetrics"] = "InvoiceMetrics";
    QueryKeys["NotificationSettings"] = "NotificationSettings";
    QueryKeys["PayoutInvoices"] = "PayoutInvoices";
    QueryKeys["Agreements"] = "Agreements";
    QueryKeys["QboClasses"] = "QboClasses";
    QueryKeys["QboItems"] = "QboItems";
    QueryKeys["XeroItems"] = "XeroItems";
    QueryKeys["QboCustomers"] = "QboCustomers";
    QueryKeys["XeroCustomers"] = "XeroCustomers";
    QueryKeys["TeamInvites"] = "TeamInvites";
    QueryKeys["ServiceTemplates"] = "ServiceTemplates";
    QueryKeys["ServiceTemplateBundles"] = "ServiceTemplateBundles";
    QueryKeys["QboTimeActivities"] = "QboTimeActivities";
    QueryKeys["PersonaKYBStatus"] = "PersonaKYBStatus";
    QueryKeys["Integrations"] = "Integrations";
    QueryKeys["IntegrationsSummary"] = "IntegrationsSummary";
    QueryKeys["TasksJobs"] = "TasksJobs";
    QueryKeys["InvoiceDraftDates"] = "InvoiceDraftDates";
    QueryKeys["BillingControlData"] = "BillingControlData";
    QueryKeys["ContactAgreements"] = "ContactAgreements";
    QueryKeys["IsLastOwner"] = "IsLastOwner";
    QueryKeys["AdHocScheduledData"] = "AdHocScheduledData";
    QueryKeys["InvoiceDraftByDate"] = "InvoiceDraftByDate";
    QueryKeys["RelationshipSummaries"] = "RelationshipSummaries";
    QueryKeys["RelationshipServiceNames"] = "RelationshipServiceNames";
    QueryKeys["Invoices"] = "Invoices";
    QueryKeys["Payouts"] = "Payouts";
    QueryKeys["ClientBillingOverview"] = "ClientBillingOverview";
    QueryKeys["ClientFutureInvoices"] = "ClientFutureInvoices";
    QueryKeys["CustomerPaymentMethods"] = "CustomerPaymentMethods";
    QueryKeys["ClientAgreementsForConnect"] = "ClientAgreementsForConnect";
    QueryKeys["ClientPaymentMethods"] = "ClientPaymentMethods";
    QueryKeys["ReferenceFields"] = "ReferenceFields";
    QueryKeys["SalesTaxConfig"] = "SalesTaxConfig";
    QueryKeys["SalesTaxComponents"] = "SalesTaxComponents";
    QueryKeys["InvoiceTaxPreview"] = "InvoiceTaxPreview";
    QueryKeys["ClientTaxExemptionCertificateUrl"] = "ClientTaxExemptionCertificateUrl";
    QueryKeys["RefundState"] = "RefundState";
    QueryKeys["CalculateRefundPerLine"] = "CalculateRefundPerLine";
    QueryKeys["DraftsAiSearchState"] = "DraftsAiSearchState";
    QueryKeys["AgreementsAiSearchState"] = "AgreementsAiSearchState";
    QueryKeys["PulseOpportunities"] = "PulseOpportunities";
    return QueryKeys;
}({});
